import { mapperBlockCallToAction } from '#layers/core/data-layer/blocks/mappers'
import { mapperModuleMedia } from '#layers/core/data-layer/modules/mappers'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page legal detail mapper
 * normalizes data to be used in pages
 *
 * @param {Object} data - cms data
 * @return {Object} - normalized page data
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    contentLocale: data.locale || '',
    defaultLocaleFallbackEnabled: data.defaultLocaleFallbackEnabled || false,
    introText: data.introText || null,
    chapters: data.chaptersCollection?.items || [],
    isChaptersNumbered: data.numberedDocument || false,
    callToAction: mapperBlockCallToAction(data.callToAction, options.getUrl),
    downloadDocument: mapperModuleMedia(data?.downloadDocument)?.link || null,
    navigationItems:
      data?.parent?.itemsCollection?.items.filter(Boolean).map((item) => ({
        title: item.navigationTitle,
        url: options.getInternalUrl(item.sys.id)
      })) || []
  }
}
